import { captureException } from '@sentry/react';

import { getFirebaseAuthInstance } from './auth';
import { updateUserSettings } from './store';

/** Persists the language for signed-in users; signed-out the choice stays device-local (localStorage). */
export const persistLanguage = async (language: string): Promise<void> => {
  const userId = getFirebaseAuthInstance()?.currentUser?.uid;
  if (!userId) return;

  await updateUserSettings(userId, { language }).catch(captureException);
};
